import { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { filterConsistencyParamDeclarations } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";

import type { PublisherAnalysisParamsDefinition } from "./publisherAnalysisRoutes.types";

export const params: PublisherAnalysisParamsDefinition = {
    key: {
        type: "string",
        dynamic: false,
    },
    duration: {
        type: "string",
        value: BasicDurations.LAST_TWENTY_EIGHT_DAYS,
    },
    webSource: {
        type: "string",
        value: devicesTypes.DESKTOP,
    },
    country: {
        type: "int",
        array: false,
        value: 840,
    },
    isWWW: {
        type: "string",
        value: "*",
    },
    adsViewType: {
        type: "int",
        array: false,
        value: 0,
    },
    pdf: {
        type: "bool",
        array: false,
        value: false,
    },
    ...filterConsistencyParamDeclarations,
} as const;

export const ROUTES = {
    home: "adintelligence-publisheranalysis.homepage",
    overview: "adintelligence-publisheranalysis.root.frame.overview",
    advertisers: "adintelligence-publisheranalysis.root.frame.advertisers",
    ads: "adintelligence-publisheranalysis.root.frame.ads",
    adNetworks: "adintelligence-publisheranalysis.root.frame.adnetworks",
} as const;
